import styled from 'styled-components'

export const Hero = styled.figure`
  margin-bottom: 24px;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`
export const Banner = styled.figure`
  img {
    width: 100%;
  }
`

export const SpecialtiesContent = styled.div`
  max-height: calc(100vh - 304px);
  overflow: scroll;
`

export const Image = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px auto 24px;
`
